
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import ParkEventsTable from "@/modules/ParksConfig/components/ParkEvents/ParkEventsTable.vue";
  import ParkEventsFilters from "@/modules/ParksConfig/components/ParkEvents/ParkEventsFilters.vue";
  import ParkEventRow from "@/modules/ParksConfig/components/ParkEvents/ParkEventRow.vue";
  import {httpResource} from "@/resources/http.resource";
  import store from "@/store/store";
  import {IParkEvent} from "@/modules/ParksConfig/interfaces/park-event.interface";
  import {bus} from "@/plugins/bus";
  import moment from "moment";
  import {IApp} from "@/interfaces/app.interface";

  @Component({
    components: {
      ParkEventRow,
      ParkEventsFilters,
      ParkEventsTable,
      AppDialog,
    },
  })
  export default class ParkEventsLogPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'parksConfig', dialogName: 'parkEventsLog' };
    tableData = [];
    cellProps = [
      { label: 'Дата', prop: 'DateEvent' },
      { label: 'Событие', prop: 'eventName' },
      { label: 'Автор', prop: 'persName' },
    ];

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async mounted() {
      let asyncAction = async () => {
        const action = IParkEvent.Action.FreeScheduleMake;
        const params: any = {
          command: IParkEvent.Command.EventsLog,
          id: this.payloadPopup.id,
        };
        const response = await httpResource.httpAction({ action, params });
        this.tableData = response.data.result.eventsLog.map(item => {
          return {
            ...item,
            DateEvent: item.DateEvent ? moment(item.DateEvent).format(IApp.DateFormats.PrintedDateTime) : '',
          }
        });
      };
      return await store.dispatch('defaultResourceAction', { asyncAction });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
